// extracted by mini-css-extract-plugin
module.exports = {"lia-link-disabled":"PagerPreviousNextLinkable_lia-link-disabled__gTLvW"};